import { demoFile, feature, component } from 'system/demo';
import { JumpToCommentFeature, CommentHighlight as commentHighlightStyle, ScrollToComment, ExpandRepliesWidget } from '../jump-to-comment';
import React from 'react';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('open-modules/zdf/feature/jump-to-comment');

function CommentHighlight({ comment }) {
    const style = commentHighlightStyle({ comment });
    return <div style={style || undefined}></div>;
}

function CommentHighlightDemo({ comment }) {
    return <CommentHighlight comment={comment} />;
}

function ScrollToCommentDemo({ comment }) {
    return <ScrollToComment comment={comment} />;
}

function ExpandRepliesWidgetDemo() {
    return <ExpandRepliesWidget />;
}

feature('Jump To Comment', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    state: {
        screenParams: { commentID: 'c2' },
        collections: {
            comment: [
                { key: 'c1', from: 'u1', text: 'parent', time: 0 },
                { key: 'c2', from: 'u2', text: 'reply', replyTo: 'c1', time: 0 }
            ]
        },
        language: 'english'
    },
    features: { jumptocomment: true }
});

const baseState = {
    screenParams: { commentID: 'c2' },
    collections: {
        comment: [
            { key: 'c1', from: 'u1', text: 'parent', time: 0 },
            { key: 'c2', from: 'u2', text: 'reply', replyTo: 'c1', time: 0 }
        ]
    },
    language: 'english'
};

component('CommentHighlight', CommentHighlightDemo, {
    structureKey: 'simplecomments',
    state: baseState,
    args: { comment: { key: 'c2', from: 'u2', text: 'reply', replyTo: 'c1', time: 0 } }
});

component('ScrollToComment', ScrollToCommentDemo, {
    structureKey: 'simplecomments',
    state: baseState,
    args: { comment: { key: 'c2', from: 'u2', text: 'reply', replyTo: 'c1', time: 0 } }
});

component('ExpandRepliesWidget', ExpandRepliesWidgetDemo, {
    structureKey: 'simplecomments',
    state: baseState
});

